/* eslint-disable react/require-default-props */
import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import { useWindowResize } from '../../../hooks/useWindowSize'
import breakpoints from '../../../theme/breakpoints'

type RuleNames = 'header'

interface StyleProps {
    gridTemplateColumns?: string
}

const useStyles = createUseStyles<RuleNames, StyleProps, Jss.Theme>({
    header: {
        display: 'grid',
        gridTemplateColumns: ({ gridTemplateColumns }) => {
            return gridTemplateColumns
        },
    },
})

const cellStyles = createUseStyles({
    headerCell: {
        padding: '.7rem 1rem',
    },
})

const CardHeader: React.FC<Props> = ({
    children,
    gridTemplateColumns = 'repeat( auto-fit, minmax(1px, 1fr) )',
}) => {
    const theme = useTheme<Jss.Theme>()
    const classes = useStyles({ ...{ gridTemplateColumns }, theme })

    return <div className={classes.header}>{children}</div>
}

const CardHeaderCell: React.FC = ({ children }) => {
    const windowSize = useWindowResize()
    const classes = cellStyles()

    if (windowSize.width >= breakpoints.Desktop) {
        return <div className={classes.headerCell}>{children}</div>
    }

    return null
}

type Props = {
    gridTemplateColumns?: string
}

export { CardHeader, CardHeaderCell }
